var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _circle2, _path8, _path9, _path10, _path11, _circle3, _path12, _path13, _path14, _path15, _path16, _path17, _circle4, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyOccurrences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 930.675,
    height: 521.876,
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M78.71 429.914a158.4 158.4 0 0 0 28.728 33.862c.254.231.515.453.776.681l23.738-14.105q-.264-.359-.577-.8c-12.394-17.255-68.372-132.055-68.714-157.478-.043 2.105-20.146 81.116 16.05 137.84",
    "data-name": "Path 133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M102.858 466.497q.55.248 1.118.478l17.809-10.582q-.417-.242-.974-.563c-6.097-3.561-24.238-14.262-42.099-25.917-19.191-12.526-38.071-26.145-41.347-33.188.682 1.621 21.812 50.872 65.493 69.772",
    "data-name": "Path 134"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M855.2 476.194a158.4 158.4 0 0 1-7.4 43.785c-.1.329-.21.653-.319.982h-27.613q.045-.444.088-.982c1.841-21.166-8.677-148.453-21.369-170.483 1.112 1.787 58.754 59.444 56.613 126.698",
    "data-name": "Path 133"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M853.128 519.979q-.346.495-.717.982h-20.716c.157-.28.34-.61.55-.982 3.422-6.176 13.551-24.642 22.953-43.785 10.1-20.572 19.374-41.924 18.593-49.652.242 1.742 7.234 54.876-20.663 93.437",
    "data-name": "Path 134"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M448.068 520.193H128.74a28.58 28.58 0 0 1-28.548-28.548V28.548A28.58 28.58 0 0 1 128.74 0h319.328a28.58 28.58 0 0 1 28.548 28.548v463.097a28.58 28.58 0 0 1-28.548 28.548"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M448.63 501.979H128.178a8.81 8.81 0 0 1-8.8-8.8V27.014a8.81 8.81 0 0 1 8.8-8.8H448.63a8.81 8.81 0 0 1 8.8 8.8V493.18a8.81 8.81 0 0 1-8.8 8.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 287.19,
    cy: 8.743,
    r: 2.429,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M929.485 521.876H1.19a1.19 1.19 0 1 1 0-2.381h928.294a1.19 1.19 0 1 1 0 2.381"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.401,
    cy: 355.346,
    r: 31,
    fill: "#e4e4e4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4e4e4",
    d: "M307.81 295.847h-38.817l-23.434-114.63a43.06 43.06 0 1 1 85.692-.052Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M440.918 141.766h141.874a30.16 30.16 0 0 1 29.42 23.527L683.9 483.26a24.376 24.376 0 0 1-22.58 29.707l-145.847 7.185a32.2 32.2 0 0 1-33.273-26.431l-40.664-224.807-7.692-42.523-11.351-62.752a18.57 18.57 0 0 1 18.426-21.874"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M564.114 148.62h16.561a20.84 20.84 0 0 1 20.364 16.4l68.809 315.374a12.915 12.915 0 0 1-11.774 15.64L512.7 505.562a16.726 16.726 0 0 1-17.555-13.725l-58.715-325.97a14.65 14.65 0 0 1 14.418-17.246h15.71a6.914 6.914 0 0 1 6.676 5.116 6.104 6.104 0 0 0 5.894 4.517h74.584a10.434 10.434 0 0 0 10.403-9.633"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb6b6",
    d: "M637.487 249.714a10.5 10.5 0 0 1 1.316 1.007l48.056-12.25 3.279-11.594 18.143 2.66-3.81 21.089a8 8 0 0 1-7.034 6.533l-56.111 5.91a10.497 10.497 0 1 1-3.84-13.355"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 603.192,
    cy: 262.195,
    r: 31,
    fill: "#286795"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#286795",
    d: "M622.6 202.695h-38.816L560.35 88.065a43.06 43.06 0 1 1 85.692-.051Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m711.524 240.061-12.38 10.68-17.32 14.93-7.65-39.14-.8-4.07-.63-3.23 17.55-30.57 14.63.84 1 .06.02.22.23 2.05 3 26.98.07.65z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb6b6",
    d: "m630.606 507.736-12.26-.001-5.833-47.288 18.095.001z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m633.732 519.62-39.53-.002v-.5a15.387 15.387 0 0 1 15.386-15.386l24.145.001Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb6b6",
    d: "m758.606 508.736-12.26-.001-5.833-47.288 18.095.001z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m761.732 520.62-39.53-.002v-.5a15.387 15.387 0 0 1 15.386-15.386l24.145.001ZM768.404 487.911l-33 5-48.01-162.48-50.99 163.48-37-5 48-190v-15l6.5-22.5-.68-6.09-4.73-42.59-2.05-18.47-.133-1.193a4.056 4.056 0 0 1 3.193-4.417l15.4-3.24h25.17l14.85 4.09 1.02.28.46.13-.23 1.92-3.48 29.18-.19 1.6-3.36 28.13-.74 6.17c29 21 30 42 30 42Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 674.447,
    cy: 148.199,
    r: 24.561,
    fill: "#ffb6b6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m651.658 257.621 48.586-6.354.908 6.941-48.586 6.354z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb6b6",
    d: "M586.487 259.714a10.5 10.5 0 0 1 1.316 1.007l48.056-12.25 3.279-11.594 18.143 2.66-3.81 21.089a8 8 0 0 1-7.034 6.533l-56.111 5.91a10.497 10.497 0 1 1-3.84-13.355"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m660.404 194.911-8.5-6.5c-2.298-.871-5.447 1.605-6 4l-12 49 25 18 3.5-5.5Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M709.174 218.811a68 68 0 0 1-6.48 2.2c-.7.21-1.42.41-2.13.6a66 66 0 0 1-14.34 2.32 45 45 0 0 1-6.26-.17 35.2 35.2 0 0 1-6.59-1.3l-.22-.06a28.9 28.9 0 0 1-11.95-6.79 24 24 0 0 1-2.11-2.35 21.24 21.24 0 0 1-4.56-16.53 14 14 0 0 1 .34-1.57 25 25 0 0 1 1.49-4.1c.27-.62.57-1.23.89-1.83l11.3-3.82h21.52l14.85 4.09 1 .06.02.22.46.13-.23 1.92Z",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M655.627 127.865c-4.593-.563-9.634-.165-13.214 2.767s-4.736 9.028-1.346 12.178c3 2.79 7.693 2.134 11.713 2.927a15.854 15.854 0 0 1 12.383 15.156c-.06 10.174-9.824 17.88-11.578 27.901-1.197 6.84 1.688 14.038 6.675 18.87s11.844 7.442 18.751 8.15 13.893-.373 20.606-2.148c6.741-1.782 13.378-4.31 19.034-8.388s10.293-9.826 12.11-16.558.512-14.45-4.168-19.62c-5.36-5.919-14.275-7.954-18.91-14.455-5.197-7.288-3.274-17.666-7.48-25.568-2.807-5.275-8.124-8.873-13.791-10.768s-11.72-2.27-17.692-2.453c-3.14-.097-6.376-.129-9.3 1.016s-5.497 3.753-5.649 6.89 1.856 4.103 1.856 4.103"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOccurrences);
export default __webpack_public_path__ + "static/media/empty_occurrences.cd5f35cfd3ef42f88f58902b5dc3e723.svg";
export { ForwardRef as ReactComponent };